var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn-back-to-top ${_vm.isShowBtn ? '' : 'none'}`,on:{"click":_vm.backToTop}},[_c('Icon',{attrs:{"name":"arrow_up"}}),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.isMobile)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }